//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetchAll, changeStatus, _STATUS } from "@/apis/members"

import moment from 'moment';
export default {
    data() {
        return {
            config: {
                status:[]
            },
            checkStrictly: false,
            data: [],
            records: [],
            columns: [],
            rowSelection: {},
            searchQuery: {
                status: "",
                name: "",
                phone: "",
            },
            //table loading
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns.push({ title: '客戶ID', dataIndex: 'id', key: 'id', width: 180, })
        this.columns.push({ title: '客戶手機', dataIndex: 'phone', key: 'phone', width: 180, })
        this.columns.push({ title: 'EMAIL', dataIndex: 'email', key: 'email', width: 280, })
        this.columns.push({ title: '客戶姓名', dataIndex: 'name', key: 'name', width: 180, })
        this.columns.push({ title: '性別', key: 'gender', width: 180, scopedSlots: { customRender: 'genderSlot' }, })
        this.columns.push({ title: '客戶點數', dataIndex: 'paidPoints', key: 'paidPoints', width: 180, })
        this.columns.push({ title: '免費點數', dataIndex: 'freePoints', key: 'freePoints', width: 180, })
        this.columns.push({ title: '註冊時間', dataIndex: 'createdTime', key: 'createdTime', width: 180, })
        this.columns.push({ title: '登錄時間', dataIndex: 'lastLoginTime', key: 'lastLoginTime', width: 180, })
        this.columns.push({ title: '客戶狀態', dataIndex: 'status', key: 'status', width: 120, scopedSlots: { customRender: 'statusSlot' }, })
        this.columns.push({
            title: '操作',
            key: 'operation',
            //fixed: 'right',
            width: 120,
            scopedSlots: { customRender: 'action' },
        });

        this.onPageConfig();
        this.onPageLoad();
    },
    methods: {
        moment,
        async onPageConfig() {
            try {
                let _status = [];
                Object.keys(_STATUS).forEach(value => {
                    _status.push({
                        id: value,
                        name: _STATUS[value]
                    })
                })
                this.config.status = _status;

            } catch (error) {
                this.$message.error(error.message);
            }
        },
        // execute Search Request
        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        changeStauts(record) {
            let status = !record.status;

            changeStatus({
                id: record.id,
                status: status
            }).then(res => {
                this.$message.success("Succed");
                this.onPageLoad();
            })
        },
       
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.records = this.parseRecords(res.data.records);
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        parseRecords(records) {
            records.forEach(record => {

                record.point = record.point === undefined ? 0 : record.point;
                record.freepoint = record.freepoint === undefined ? 0 : record.freepoint;

            });
            return records;

        },

        onChange(value, option, type) {
            this.searchQuery.status = value.key;
        },

        onSelect: (record, selected, selectedRows) => {
            console.log(record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log(selected, selectedRows, changeRows);
        },
        handleFinish() {

        },
        handleFinishFailed() {

        },
        onSearch() {
            this.onPageLoad();
        },
        // toDetails(id) {
        //     this.$router.push(`/clients/${id}`);
        // },
        // toInstallForm() {
        //     this.$router.push(`/clients/add`);
        // },
        toEdit(id) {
            this.$router.push(`/member/edit/${id}`);
        },
        toAccountEdit(id) { 
            this.$router.push(`/member/account-record/edit/${id}`);
        }
    }
}
